module.exports = __webpack_public_path__ + "static/futur-call-4-f0daaf870144af1a7cec3fc984f2a2bd.jpg";